import React, { } from 'react'
import { Grid, IconButton } from '@mui/material'
import {
    MainContainer,
    ChatContainer,
    MessageList,
    Message,
    ConversationHeader,
    MessageSeparator,
    MessageGroup
} from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns'

const RichiesteSupportoContainer = ({ idPratica, closeRichiesteSupporto, listRichiesteSupporto }) => {

    const messaggioRichiesta = "ha richiesto supporto con il seguente messaggio: "
    const utentiRichiesta = "Inviato ai gruppi: "
    const messaggioRisposta = "ha risposto alla richiesta di supporto con il seguente messaggio: "
    const utenteRisposta = "Inviato all'utente: "

    const checkIfRispostaSupporto = (inputTipoMessaggio) => {
        return inputTipoMessaggio.toLowerCase().includes("risposta richiesta supporto")
    }

    return (
        <Grid marginLeft={1} marginBottom={'5px'} height={'700px'} width={'550px'} >
            <MainContainer >
                <ChatContainer >
                    <ConversationHeader>
                        <ConversationHeader.Content
                            userName="Richieste di supporto"
                        >
                        </ConversationHeader.Content>
                        <ConversationHeader.Actions>
                            <IconButton sx={{ paddingX: '5px' }} type="button" onClick={closeRichiesteSupporto}>
                                <CloseIcon
                                    title="Chiudi Richieste di supporto"
                                ></CloseIcon>
                            </IconButton>
                        </ConversationHeader.Actions>
                    </ConversationHeader>
                    <MessageList >

                        {listRichiesteSupporto.map((richiesta, i) => (
                            <MessageGroup direction={checkIfRispostaSupporto(richiesta.tipoMessaggio) ? 'outgoing' : 'incoming'}>
                                <MessageGroup.Messages key={'richiestasupporto-' + i}>
                                    <MessageSeparator className="messageSeparator" content={format(new Date(richiesta.data), 'dd/MM/yyyy HH:mm')} as="h2" />
                                    <Message
                                        className={checkIfRispostaSupporto(richiesta.tipoMessaggio) ? 'risposta' : 'richiesta'}

                                        model={{
                                            message: `<b>${richiesta.idUtente.username}</b> ${checkIfRispostaSupporto(richiesta.tipoMessaggio) ? messaggioRisposta : messaggioRichiesta} <br><br>"${richiesta.messaggio}"`,
                                            direction: `${checkIfRispostaSupporto(richiesta.tipoMessaggio) ? 'outgoing' : 'incoming'}`
                                        }} />

                                </MessageGroup.Messages>
                                <MessageGroup.Footer style={{ flexDirection: checkIfRispostaSupporto(richiesta.tipoMessaggio) ? "row-reverse" : "row" }}>{checkIfRispostaSupporto(richiesta.tipoMessaggio) ? (utenteRisposta + richiesta.destinatario) : (utentiRichiesta + richiesta.destinatario)}</MessageGroup.Footer>
                            </MessageGroup>
                        ))
                        }
                    </MessageList>
                </ChatContainer>
            </MainContainer>
        </Grid>
    )
}

export default RichiesteSupportoContainer
